import React from "react";
import styled from "styled-components";

export default styled.img`
    max-width: 70%;
    max-height: 200px;
    border-radius: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/ProfileImage.js